import { render, staticRenderFns } from "./CreatePost.vue?vue&type=template&id=015a00e0&scoped=true&"
import script from "./CreatePost.vue?vue&type=script&lang=js&"
export * from "./CreatePost.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "015a00e0",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Attivita\\SVILUPPO Laravel\\archilogy\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('015a00e0')) {
      api.createRecord('015a00e0', component.options)
    } else {
      api.reload('015a00e0', component.options)
    }
    module.hot.accept("./CreatePost.vue?vue&type=template&id=015a00e0&scoped=true&", function () {
      api.rerender('015a00e0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/components/Post/CreatePost.vue"
export default component.exports